<template>
    <div>
      <ul class="side-menu" :class="menuClass">
          <li v-scroll-to="'#companies'">الشركات</li>
          <li v-scroll-to="'#videos'">طق حنك</li>
          <li v-scroll-to="'#articles'">حكــي جـرايــد</li>
          <li v-scroll-to="'#awards'">جوائز وإنجازات</li>
          <li v-scroll-to="'#books'">كُتُـــب</li>
          <li v-scroll-to="'#social'">شبكات التواصل</li>
      </ul>
      <nav id="fixed-menu" class="flexed">
        <div id="burger-icon" @click="menu" :class="menuClass">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="zaidoun-social">
          <a href="https://web.facebook.com/zaidounkaradsheh" target="_blank"><i class="fa fa-facebook"></i></a>
          <a href="https://twitter.com/zaidounk?lang=ar" target="_blank"><i class="fa fa-twitter"></i></a>
          <a href="https://www.instagram.com/zaidounk/" target="_blank"><i class="fa fa-instagram"></i></a>
          <a href="https://www.youtube.com/user/Shoufet3ainak/" target="_blank"><i class="fa fa-youtube"></i></a>
          <a href="https://www.linkedin.com/in/zaidounkaradsheh/" target="_blank"><i class="fa fa-linkedin"></i></a>
        </div>
        <div class="zaidoun-karadsheh">
          زيــــدون كرادشــــة
        </div>
      </nav>
    </div>
</template>

<script>
export default {
  data () {
      return {
        menuStatus: false,
        menuClass: ''
      }
  },
  methods: {
    menu() {
      this.menuStatus = !this.menuStatus
      if(this.menuStatus === true){
        this.menuClass = 'open'
      } else {
        this.menuClass = ''
      }
    }
  },
  created () {
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sections/Menu.vue